import { graphql } from 'gatsby';
import React, { useMemo } from 'react';

import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import ConnectAndContribute from '../components/ConnectAndContribute/ConnectAndContribute';
import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle/PageTitle';
import SideBar from '../components/SideBar/SideBar';
import NestedPages from '../components/pages/NestedPages/NestedPages';
import SEO from '../components/seo';
import { PageProps } from '../entities/Page';
import { BACK, PROGRAMMING_PAGE, SIDEBAR_EXAMPLES, SIDEBAR_PROGRAMMING } from '../utils/constants';
import { getSideBarDataRefactored } from '../utils/functions';

const titleDescription = {
  title: 'Built-in Examples',
  description: 'Learn the basics of Arduino through this collection tutorials. All code examples are available directly in all IDEs.',
};

export default function BuiltInExamples({ data }: PageProps): React.ReactElement {
  const buildInExamplesRefactoredData = useMemo(() => {
    return getSideBarDataRefactored(data);
  }, [data]);

  return (
    <Layout>
      <SEO {...titleDescription} />
      <main className="page-container">
        <SideBar
          links={[]}
          nestedCategories={buildInExamplesRefactoredData}
          actualPage={titleDescription.title}
          prevPage={{ title: BACK, pathname: '/programming/' }}
        />
        <div className="page-layout build-in">
          <Breadcrumbs
            actualPage={SIDEBAR_EXAMPLES}
            list={[
              { title: 'Home', url: '/' },
              { title: SIDEBAR_PROGRAMMING, url: PROGRAMMING_PAGE },
              { title: SIDEBAR_EXAMPLES, url: null },
            ]}
          />
          <PageTitle {...titleDescription} />
          <NestedPages>{data.pages}</NestedPages>
          <ConnectAndContribute />
        </div>
      </main>
    </Layout>
  );
}

export const pageQuery = graphql`
  {
    pages: allFile(filter: { fields: { type: { eq: "built-in-examples" } } }, sort: { relativeDirectory: ASC }) {
      edges {
        node {
          relativeDirectory
          name
          fields {
            slug
          }
          childMdx {
            frontmatter {
              title
              description
              icon
            }
          }
        }
      }
    }
  }
`;
